export enum KEY_STATUS {
  IDLE = "IDLE",
  IN_RELAY = "IN_RELAY",
  WITH_SOMEBODY = "WITH_SOMEBODY",
  ARCHIVED = "ARCHIVED",
}

export enum KEY_SECONDARY_STATUS {
  LATE = "LATE",
  LOST = "LOST",
  IN_TRANSIT = "IN_TRANSIT",
}

export interface IKeyStatusFilter {
  value: string;
  isSecondary: boolean;
}

// Union of primary and secondary key statuses, used to build key status filters
// without a round-trip to fetch the distinct statuses in DB (GET /api/keys/status)
// ARCHIVED is excluded: archived keys are filtered separately (archivedAt), so this
// status would always return an empty result set.
export const KEY_STATUS_FILTERS: IKeyStatusFilter[] = [
  ...Object.values(KEY_STATUS)
    .filter((value) => value !== KEY_STATUS.ARCHIVED)
    .map((value) => ({ value, isSecondary: false })),
  ...Object.values(KEY_SECONDARY_STATUS).map((value) => ({ value, isSecondary: true })),
];

export function splitKeyStatusFilters(selected: IKeyStatusFilter[] = []): {
  statuses: string[];
  secondaryStatuses: string[];
} {
  return {
    statuses: selected.filter((s) => !s.isSecondary).map((s) => s.value),
    secondaryStatuses: selected.filter((s) => s.isSecondary).map((s) => s.value),
  };
}

// Only one status can be selected at a time, regardless of type: checking one unselects
// any other previously selected status.
export function applyExclusiveKeyStatusFilterChange(
  previousSelection: IKeyStatusFilter[],
  newSelection: IKeyStatusFilter[],
  clicked: IKeyStatusFilter,
): IKeyStatusFilter[] {
  const wasJustChecked = newSelection.length > previousSelection.length;
  return wasJustChecked ? [clicked] : newSelection;
}
